export default __webpack_public_path__ + "static/media/Phortahz Crossbow.d02790b7.jpg";